
import { Component, Vue } from "vue-property-decorator";
import DetailsSummaryPage from "@/components/DetailsSummaryPage/DetailsSummaryPage.vue";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";
import { SMUser } from "@/store";

const ICONS = {
  lock: "lock-closed",
};

@Component({
  components: {
    DetailsSummaryPage,
    NotificationTemplate,
    ComplianceExpiredWidget: () => import("@/modules/Compliance/ComplianceExpiredWidget.vue"),
  },
})
export default class EmploymentProfile extends Vue {
  icons = ICONS;

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }
}
